import { Component, Input } from '@angular/core';
import { XpressDeliveryOrderDetail, TextTransformType } from '@shared/models';

@Component({
	selector: 'booking-timeline-tab',
	templateUrl: './booking-timeline-tab.component.html',
	styleUrl: './booking-timeline-tab.component.scss'
})
export class RideTimelineTabComponent {
	@Input() deliveryOrderDetails!: XpressDeliveryOrderDetail;
	TextTransformType = TextTransformType;
}
